import { combineReducers } from 'redux';
import members from './members.reducer';

const reducer = combineReducers({
	members
});

export default reducer;